export class CachedDetailRow<D> {
    cachedDetail?: D
}